import React from "react";

interface SvgBackEnvelopeSimpleProps {
  color?: string;
  playIconColor?: string;
  playButtonBgColor?: string;
}

const SvgBackEnvelopeSimple: React.FC<SvgBackEnvelopeSimpleProps> = ({
  color = "#CC0000",
  playIconColor = "#C00000",
  playButtonBgColor = "#FFFFFF",
}) => (
  <svg
    width="1120"
    height="720"
    viewBox="0 0 1120 720"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill={color} d="M0 0h1120v720H0z" />
    <rect
      x="80"
      y="528"
      width="112"
      height="112"
      rx="56"
      fill={playButtonBgColor}
    />
    <path
      d="m156.715 579.695-29.171-17.237c-3.333-1.97-7.544.433-7.544 4.304v34.476c0 3.871 4.211 6.274 7.544 4.304l29.171-17.237c3.275-1.936 3.275-6.674 0-8.61"
      fill={playIconColor}
    />
  </svg>
);

export default SvgBackEnvelopeSimple;
